module.exports = __webpack_public_path__ + "media/images/design/images/bn_canpan-08b4f63c08201ec2fd83901939557730.jpg";